import { useEffect, useMemo, useState } from "react";

/**
 * Shared ticker for synchronized language rotation.
 * - order: fa -> ar -> en
 * - single source of truth: index
 */
export function useSyncedLangTicker({ intervalMs = 2800, pauseOnTouch = true }) {
  const items = useMemo(
    () => [
      { lang: "fa", dir: "rtl", text: "اینجا غذای خود را سفارش دهید" },
      { lang: "ar", dir: "rtl", text: "اطلب طعامك هنا" },
      { lang: "en", dir: "ltr", text: "ORDER YOUR FOOD HERE" },
    ],
    []
  );

  const cta = useMemo(
    () => [
      { lang: "fa", dir: "rtl", text: "برای ثبت یک تجربه لذیذ" },
      { lang: "ar", dir: "rtl", text: "لتسجيل تجربة لذيذة" },
      { lang: "en", dir: "ltr", text: "For a delicious experience" },
    ],
    []
  );

  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return;

    const id = window.setInterval(() => {
      setIndex((p) => (p + 1) % 3);
    }, intervalMs);

    return () => window.clearInterval(id);
  }, [paused, intervalMs]);

  const onPause = () => pauseOnTouch && setPaused(true);
  const onResume = () => pauseOnTouch && setPaused(false);

  return {
    index,
    headline: items[index],
    cta: cta[index],
    intervalMs,
    paused,
    onPause,
    onResume,
  };
}
